import logo from "../assets/images/logo.png";
import { useSelector, useDispatch } from "react-redux";
import { isProductPage } from "../redux/products/actions";

export default function Navbar() {
    //Hooks
    const cart = useSelector((state) => state.cart);
    const dispatch = useDispatch();

    //Get total added product into cart
    const totalAmount = cart.reduce((accumulator, current) => accumulator + current.quantity, 0);

    //Functions
    const handlePageRoute = (payload) => {
        dispatch(isProductPage(payload));
    }

    return (
        <nav className="bg-[#171C2A] py-4">
            <div className="navBar">
                <a href="#home" onClick={() => handlePageRoute(true)}>
                    <img src={logo} alt="LWS" className="max-w-[140px]" />
                </a>
                <div className="flex gap-4">
                    <a href="#home" className="navHome" id="lws-home" onClick={() => handlePageRoute(true)}> Home </a>
                    <a href="#cart" className="navCart" id="lws-cart" onClick={() => handlePageRoute(false)}>
                        <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
                        <span id="lws-totalCart">{totalAmount}</span>
                    </a>
                </div>
            </div>
        </nav>
    );
}
